<template>
  <tr>
    <template v-for="(value, index) in arrWeek">
      <template v-if="value != ''">
        <td :class="{ 'active bg-color-skin-dark-10': checkSelectedDay(value),
                      'bg-hover-color-skin-light-10' : pcDisp,
                      'date-green': (checkCalendarHoliday(value) === 'date-green'),
                      'date-blue': (checkCalendarHoliday(value) === 'date-blue'),
                      'date-red': (checkCalendarHoliday(value) === 'date-red'),
                      'date-grey': (checkCalendarHoliday(value) === 'date-grey')}"
            v-on:click="autoFocus(value, index)"
            :key="index">
          <a :class="{ 'fa fa-star star star-layout' : checkCalendarMain(value) }" class="color-skin"></a>
          <div :class="{ 'selected-day border-color-skin set-position' : checkCurrentDay(value) }">
            <div class="set-number-date">{{ value }}</div>
          </div>
        </td>
      </template>
      <template v-else>
        <td><div></div></td>
      </template>
    </template>
  </tr>
</template>

<script>
export default {
  name: 'week-row',
  methods: {
    autoFocus (value, index) {
      this.setSelectDate({ date: value, day: index })
      this.autoFocusCalendarTab({ tab: 'tab1', calendarTabRows: this.calendarTab1.rows })
      this.autoFocusCalendarTab({ tab: 'tab2', calendarTabRows: this.calendarTab2.rows })
      this.autoFocusCalendarTab({ tab: 'tab3', calendarTabRows: this.calendarTab3.rows })
      this.autoFocusCalendarTab({ tab: 'tab4', calendarTabRows: this.calendarTab4.rows })
    }
  },
  props: [ 'arrWeek', 'checkCalendarMain', 'setSelectDate', 'checkCurrentDay', 'checkSelectedDay', 'checkCalendarHoliday', 'pcDisp', 'autoFocusCalendarTab', 'calendarTab1', 'calendarTab2', 'calendarTab3', 'calendarTab4' ]
}
</script>

<style lang='scss'>
  .dash-calendar {
  	.star-layout {
  		/*float: left;
  		margin:-15px 0 0 5px;*/
  		position:absolute;
  		top:2px;
  		left:2px;
  	}

  	.set-number-date{
  		padding: 4px 0 0 0;
  		width:100%;
  		font-size:16px;
  		position: absolute;
  		left:0%;
  	}
  }

</style>



// WEBPACK FOOTER //
// weekRow.vue?4b4aaddc